import React, { useState } from "react";
import { Link } from 'react-router-dom';
import { motion } from "framer-motion"


const AboutComp = () => {
    return ( 
        <>
       <div className="main_cont fixed-top">
          <nav className=" pe-3 mobile_cont d-none nav_cont">
            <ul>
                <a href="/"><img src="/images/business_logo.png" alt="logo" className="img-fluid d-inline" style={{"width":"15%"}}/></a> 
              <div className="d-inline pt-4" style={{"float":"right","letterSpacing":"4px"}}>
              <Link to={"/signup"} className="nav_hid text-decoration-none mx-4 text-light"><div className="nav_box text-center activ_box" > <p className="activ">Free Offer</p></div></Link>
              <Link to={"/"}  className="nav_hid text-decoration-none mx-4 text-light"><div className="nav_box text-center" >Home</div></Link>
              <Link to={"/templates"} className="nav_hid text-decoration-none mx-4 text-light"><div className="nav_box text-center" >Websites</div></Link>
              <Link to={"/about"} className="nav_hid text-decoration-none mx-4 text-light"><div className="nav_box text-center" >About</div></Link>
              <Link to={"/policy"} className="nav_hid text-decoration-none mx-4 text-light"><div className="nav_box text-center" >Policy</div></Link>
              <a href="/" className="nav_hid text-decoration-none mx-4 text-light"><div className="nav_box text-center" >Contact</div></a>
              </div>
            </ul>
          </nav>
        

<nav className="mobile_cont d-md-none fixed-top">
<button style={{"background":"none"}} className="btn btn-white ms-3 my-4" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasWithBothOptions" aria-controls="offcanvasWithBothOptions"><i className="fa fa-bars" style={{"fontSize":"30px"}} aria-hidden="true"></i>
</button> <Link to={'/signin'}><button style={{"background":"none"}} className="btn btn-white" type="button" ><i class="fa fa-phone fw-bold text-success" style={{"fontSize":"30px"}} aria-hidden="true"></i></button></Link>
<a href='#home'><img src="/images/business_logo.png" alt="logo" className="img-fluid d-inline mx-5 my-4" style={{"width":"25%", "float":"right","transform":"scale(1.9)"}}/></a>
<div className="offcanvas offcanvas-start w-50" data-bs-scroll="true" tabindex="-1" id="offcanvasWithBothOptions" aria-labelledby="offcanvasWithBothOptionsLabel">
  <div className="offcanvas-header">
    <h5 className="offcanvas-title" id="offcanvasWithBothOptionsLabel"><Link><img src="/images/business_logo.png" alt="logo" className="img-fluid d-inline" style={{"width":"60%", "float":"left","transform":"scale(1.8)"}}/></Link>
</h5>
    <button type="button" className="btn-close btn-danger" data-bs-dismiss="offcanvas" aria-label="Close"></button>
  </div>
  <div class="mob offcanvas-body text-white" style={{ backgroundColor: "#E52020", textAlign: "center" }}>
  <Link to={"/signup"} style={{ textDecoration: "none" }}>
    <div className="w-100 p-3 text-white" style={{ fontSize: "20px" }}>
      Offer
    </div>
  </Link>
  <Link to={"/"} style={{ textDecoration: "none" }}>
    <div className="w-100 p-3 text-white" style={{ fontSize: "20px" }}>
      Home
    </div>
  </Link>
  <Link to={"/templates"} style={{ textDecoration: "none" }}>
    <div className="w-100 p-3 text-white" style={{ fontSize: "20px" }}>
      Websites
    </div>
  </Link>
  <Link to={"/about"} style={{ textDecoration: "none" }}>
    <div className="w-100 p-3 text-white" style={{ fontSize: "20px" }}>
       About
    </div>
  </Link>
  <Link to="/policy" style={{ textDecoration: "none" }}>
    <div className="w-100 p-3 text-white" style={{ fontSize: "20px" }}>
       Policy
    </div>
  </Link>
  <a href={"#contact"} style={{ textDecoration: "none" }}>
    <div className="a_log w-100 p-3 mt-3 text-white" style={{ fontSize: "20px" }}>
      Contact
    </div>
  </a>
</div>

</div>
</nav>
        </div>

                              {/*About section*/}
<div class="container my-5 pt-4 text-center">
<i class="fa fa-globe fs-1" aria-hidden="true"style={{color: "#000080"}}></i>
      <h3>Our Story</h3>
      <hr className="hr_line"></hr>
      
      <div className="container b_cont p-3 mt-3" style={{"wordBreak":"break-word","textAlign":"justify"}}>
        <p >
        Welcome to Carib Web Works, a website design business based in the beautiful Caribbean. At Carib Web Works, we're passionate about creating stunning websites that help our clients achieve their business goals. We understand that in today's digital age, having a strong online presence is essential for any business. That's why we offer a range of services to help you establish your online presence, from website design and development to search engine optimization and social media management. Our team of experienced designers and developers are dedicated to providing top-quality services that exceed our clients' expectations. We take the time to understand your business and its unique needs, ensuring that the website we create is tailored to your specific goals and objectives. At Carib Web Works, we pride ourselves on our attention to detail and commitment to excellence. We believe that every website should not only look great, but also be user-friendly, functional, and effective. That's why we use the latest technologies and techniques to ensure that your website not only meets but exceeds industry standards.
        </p>
      </div>

<div class="row g-2 mt-3">
  <div class="col-sm-4 text-center">
<div class="container b_cont" style={{"width": "100%", height: "200px", overflow: "hidden", }}>
<img src="/images/about-mission.jpg" class="img-fluid" style={{height: "100%","object-fit": "cover",width:"100%"}} />
</div>
<div class="b_cont px-2 pb-2" style={{ wordWrap:"break-word"}}>
<h5>Our Mission</h5>
<p style={{"textAlign":"justify"}}> Our aim involves recipes with the ability to acheive our clients/associates goals. Strategies were implemented to allocate the time needed to meet targets and deadlines. As we aim for success, our footprints will keep track of records while leading our competitors.</p>
</div>
</div>

<div class="col-sm-4 text-center">
<div class="container b_cont" style={{"width": "100%", height: "200px", overflow: "hidden"}}>
<img src="/images/about-plan.jpg" class="img-fluid" style={{height: "100%","object-fit": "cover",width:"100%"}} />
</div>
<div class="b_cont px-2 pb-2" style={{ wordWrap:"break-word"}}>
<h5>Values</h5>
<p style={{"textAlign":"justify"}}> All our associates are categories of good morals principle.
It doesn't matter your differences; all of us are connected.
We are not just partners; we are builders of our structure.
Adopting principles, understanding our policy will keep the building blocks together.
 A strong relationship with good intentions prove to be trustworthy.</p>
</div></div>

<div class="col-sm-4 text-center">
<div class="container b_cont" style={{"width": "100%", height: "200px", overflow: "hidden"}}>
<img src="/images/about-vision.jpg" class="img-fluid" style={{height: "100%","object-fit": "cover",width:"100%"}} />
  </div>
  <div class="b_cont px-2 pb-2" style={{ wordWrap:"break-word"}}>
  <h5>Our Vision</h5>
<p style={{"textAlign":"justify"}}> Our vision is to be the leading website design company, known for our innovative and impactful designs that empower businesses to succeed in the digital world. We strive to push the boundaries of web design, creating visually stunning websites that enhance user experiences and drive conversions.</p>
</div></div>
</div>
</div>


                                  {/*footer section*/} 
          <div className="body-footer text-center text-white" id="contact" style={{"backgroundColor":"#E52020"}}>
            <footer className="w-100 py-4 flex-shrink-0">
                <div className="container py-4">
                    <div className="row gy-4 gx-5">
                        <div className="col-lg-4 col-md-6">
                            <h5 className="h1 text-white">Contact Us</h5>
                            <p className="small text-white">Call: (876) 777-0826</p>
                            <p className="small text-white">Watsapp: (876) 777-0826</p>
                            <p className="small text-white">Email: caribwebworks@gmail.com </p>
                            <p className="small text-white">Address: Montego Bay, St. James</p>
                            <p><i class="fa fa-twitter-square me-3" aria-hidden="true"></i> 
                           <i class="fa fa-instagram me-3" aria-hidden="true"></i>
                            <i class="fa fa-facebook-square me-3" aria-hidden="true"></i>
                            </p>   
                        </div>
                        <div className="col-lg-2 col-md-6">
                            <h5 className="text-white mb-3">Menu</h5>
                            <ul className="list-unstyled text-dark">
                                <li><a className="text-warning fw-bold"  href="/">Home</a></li>
                                <li><Link className="text-warning fw-bold"  to={"/about"}>About</Link></li>
                                <li><Link className="text-warning fw-bold"  to={"/policy"}>Policy</Link></li>
                                <li><a className="text-warning fw-bold"  href="/" >FAQ</a></li>
                            </ul>
                        </div>
                        <div className="col-lg-2 col-md-6">
                            <h5 className="text-white mb-3">Menu</h5>
                            <ul className="list-unstyled">
                            <li><a className="text-warning fw-bold"  href="/">Home</a></li>
                                <li><Link className="text-warning fw-bold"  to={"/about"}>About</Link></li>
                                <li><Link className="text-warning fw-bold"  to={"/policy"}>Policy</Link></li>
                                <li><a className="text-warning fw-bold"  href="/" >FAQ</a></li>
                            </ul>
                        </div>
                        <div className="col-lg-4 col-md-6">
                        <h3 className="h1 text-white">Carib Web Works</h3>
                            <img src="/images/business_logo1.png" alt="logo" className="img-fluid d-inline my-2" style={{"width":"40%","transform":"scale(1.2)"}}/>
                            <p className="small" style={{"color":"gold"}}>"Attract more customers with digital marketing"</p>
                            <i>By: Ceo & Team</i>
                        </div>
                    </div>
                </div>
                <p className="small text-dark mb-0" id="contact">&copy; Copyrights. All rights reserved. <a className="text-primary" href="/signup" target={'_blank'}>caribwebworks.com</a></p>
            </footer>
                </div>
        </>
     );
}
 
export default AboutComp;